import styled from '@emotion/styled'
import { AnimatePresence, motion } from 'framer-motion'
import { useRecoilValue } from 'recoil'

import { captionsState, coursewareListState, viewPicIdIndexState } from '@/store/courseware'

const defAnimate = {
  initial: { opacity: 0, y: '-100px' },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: '-100px' },
  transition: {
    duration: 0.15,
    type: 'spring',
    damping: 35,
    stiffness: 600
  }
}

export default function Index() {
  const captions = useRecoilValue(captionsState)
  const coursewareList = useRecoilValue(coursewareListState)
  const viewPicIdIndex = useRecoilValue(viewPicIdIndexState)
  const course = coursewareList[viewPicIdIndex]
  return (
    <AnimatePresence>
      {captions ? (
        <Container
          {...defAnimate}
          className="absolute z-50 text-left w-full h-[20vh] text-white p-[10px] pointer-events-none overflow-hidden top-0 left-0 break-all whitespace-normal box-border bg-[#00000030]"
          dangerouslySetInnerHTML={{ __html: course?.text?.replace(/(\r\n|\n|\/n|\r)/gm, '<br/>') || '暂无提词内容' }}
        ></Container>
      ) : null}
    </AnimatePresence>
  )
}

const Container = styled(motion.div)``
